<template>
	<div class="container-fluid">

		<div class="d-flex flex-row justify-content-between align-items-start flex-wrap">
			<h2>Certificates</h2>

			<div class="d-flex flex-row align-items-baseline flex-wrap">
				<label class="mr-3">
					<input type="checkbox" v-model="includeArchived" v-on:change="fetchCerts(true)">
					Show archived certificates
				</label>
				<button class="btn btn-success mr-3" v-on:click="addCert">
					<i class="fa fa-plus"></i>
					Add Certificate
				</button>

				<context-menu
					:menu-items="[{
						icon: 'fa-upload',
						text: 'Import Certificates',
						clickFunction: 'openImportModal'
					}]"
					v-on:openImportModal="importModalVisible = true">
				</context-menu>
			</div>
		</div>

		<certificate-card
			v-for="cert in certs"
			:key="cert.id"
			:cert="cert"
			:company-certs="companyCerts"
			v-on:deleteCert="deleteCert(cert)"
			v-on:editCert="editCert(cert)"
			v-on:applyToCompanyCert="applyToCompanyCert"
			v-on:clearCertConnection="clearCertConnection(cert)"
			v-on:approveAttachedCert="approveAttachedCert(cert, $event)"
			v-on:toggleArchive="toggleArchive">
		</certificate-card>


		<modal-dialog
			:modal-visible="editModal.visible"
			:title="editModal.title"
			confirm-button-text="Save"
			v-on:confirm="saveCert"
			v-on:closeModal="cancelEditModal">

			<form-group label="Front of Certificate" col-class="col-md-5">
				<upload-field-with-panel
					api-model="CertificateUpload"
					upload-type="image/pdf"
					v-model="editModal.frontFileObj"
					v-on:uploaded="fileUploaded($event,false)"
					v-on:uploadStarted="uploadStarted"
					v-on:deleted="deletedImage(false)">
				</upload-field-with-panel>
			</form-group>

			<form-group label="Back of Certificate" col-class="col-md-5">
				<upload-field-with-panel
					api-model="CertificateUpload"
					upload-type="image/pdf"
					v-model="editModal.backFileObj"
					v-on:uploaded="fileUploaded($event,true)"
					v-on:uploadStarted="uploadStarted"
					v-on:deleted="deletedImage(true)">
				</upload-field-with-panel>
			</form-group>

			<div class="row">
				<div class="col-md-5"></div>
				<div class="col-md-7">
					<button
						type="button"
						class="btn btn-primary d-flex justify-content-center align-items-center w-100 mb-5"
						:disabled="(!editModal.payload.front_image_id && !editModal.payload.back_image_id) || predictionFetched"
						v-on:click="predictFiles">
					<object type="image/svg+xml" data="/resources/icons/sparkles.svg" class="sparkles-icon"></object>
					Auto-Fill with AI
					</button>
				</div>
			</div>

			<field label="Name of Certificate"
				   col-class="col-md-5"
				   v-model="editModal.payload.cert_name"
				   :invalid="$store.errorList.cert_name">
			</field>

			<field label="Certificate Number"
				   col-class="col-md-5"
				   v-model="editModal.payload.cert_number"
				   :invalid="$store.errorList.cert_number">
			</field>

			<field label="Issue Date"
				   col-class="col-md-5"
				   v-model="editModal.payload.issue_date"
				   :params="{type:'date'}"
				   :invalid="$store.errorList.issue_date">
			</field>

			<field label="Cert never expires"
				   col-class="col-md-5"
				   v-model="editModal.payload.never_expires"
				   :params="{type:'boolean'}">
			</field>

			<field v-if="editModal.payload.never_expires == 0"
				   label="Expiry Date"
				   col-class="col-md-5"
				   v-model="editModal.payload.expiry_date"
				   :params="{type:'date'}"
				   :invalid="$store.errorList.expiry_date">
			</field>

			<field label="Issuing Organization"
				   col-class="col-md-5"
				   v-model="editModal.payload.issuing_org"
				   :invalid="$store.errorList.issuing_org">
			</field>

			<field label="Instructor/Issuer Name"
				   col-class="col-md-5"
				   v-model="editModal.payload.instructor_name">
			</field>

			<field label="Training/Issue Location"
				   col-class="col-md-5"
				   v-model="editModal.payload.training_location">
			</field>

			<field label="Apply to Employer Certificate"
				   style="flex-grow: 1"
				   col-class="col-md-5"
				   v-model="editModal.employerCertId"
				   :params="{type:'select',options:companyCertOptions}">
			</field>

		</modal-dialog>

		<modal-dialog
			:modal-visible="deleteConfirmVisible"
			title="Delete Certificate"
			confirm-button-text="Yes, Delete"
			confirm-button-class="btn-outline-danger"
			v-on:confirm="executeDeleteCert"
			v-on:closeModal="deleteConfirmVisible = false">

			Are you sure you want to delete this certification?

		</modal-dialog>


		<employee-certificate-import-modal
			:visible="importModalVisible"
			:company-certificates="companyCerts"
			v-on:saved="bulkImportSaved"
			v-on:closeModal="importModalVisible = false">
		</employee-certificate-import-modal>

	</div>
</template>
<script type="text/javascript">
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import UploadFieldWithPanel from "@/components/super_components/UploadFieldWithPanel"
import FormGroup from "@/components/FormGroup"
import CertificateCard from "@/components/CertificateCard"
import ContextMenu from "@/layout_fragments/ContextMenu"
import EmployeeCertificateImportModal from "@/components/super_components/EmployeeCertificateImportModal"

import moment from "moment"

export default {
	name: "EmployeeCertificates",
	components: {
		ModalDialog,
		Field,
		UploadFieldWithPanel,
		FormGroup,
		ContextMenu,
		CertificateCard,
		EmployeeCertificateImportModal
	},
	props: ["blockFetches"],
	data() {
		return {
			certs: [],
			companyCerts: [],
			includeArchived: false,
			editModal: {
				visible: false,
				title: "Add Certificate",
				editing: false,
				backImageUrl: false,
				frontImageUrl: false,
				backIsPdf: false,
				frontIsPdf: false,
				uploadingInProgress: 0,
				payload: {},
				employerCertId: null,
				frontFileObj: null,
				backFileObj: null
			},
			importModalVisible: false,
			deleteConfirmVisible: false,
			deleteId: null,
			predictionFetched: false  // have we already fetched a prediction for the front/back images?
		}
	},
	watch: {
		blockFetches() {
			if (!this.blockFetches)
				this.fetchData()
		}
	},
	computed: {
		companyCertOptions() {
			return this.optionify(this.companyCerts,"cert_name")
		}
	},
	methods: {

		mapPredictionToCertificate(pred) {

			// Certificate name
			this.editModal.payload.cert_name = ('certificate_name' in pred) ? pred.certificate_name : ''
			this.$store.errorList.cert_name = !Boolean(this.editModal.payload.cert_name)

			// Certificate number
			this.editModal.payload.cert_num = ('certificate_number' in pred) ? pred.certificate_number : ''
			this.$store.errorList.cert_num = !Boolean(this.editModal.payload.cert_num)

			// Issue date
			this.editModal.payload.issue_date = null
			try {
				const issueDate = moment.utc(pred.issue_date).format("YYYY-MM-DD");
				this.editModal.payload.issue_date = issueDate
			} catch {}
			this.$store.errorList.issue_date = !Boolean(this.editModal.payload.issue_date)
			

			// Expiry date
			this.editModal.payload.never_expires = false
			this.editModal.payload.expiry_date = null
			try {
				this.editModal.payload.never_expires = !Boolean(pred.expiry_date)
				const expiryDate = moment(pred.expiry_date).utc().format("YYYY-MM-DD")
				this.editModal.payload.expiry_date = expiryDate
			} catch {}
			this.$store.errorList.expiry_date = !Boolean(this.editModal.payload.expiry_date)


			// Issuing organization
			this.editModal.payload.issuing_org = ('issuing_organization' in pred) ? pred.issuing_organization : ''
			this.$store.errorList.issuing_org = !Boolean(this.editModal.payload.issuing_org)

			// Instructor/Issuer Name
			this.editModal.payload.instructor_name = ('instructor_name' in pred) ? pred.instructor_name : ''
			this.$store.errorList.instructor_name = !Boolean(this.editModal.payload.instructor_name)

			// Training/Issue Location
			this.editModal.payload.training_location = ('location' in pred) ? pred.location : ''
			this.$store.errorList.training_location = !Boolean(this.editModal.payload.training_location)

			// Employer Certificate
			this.editModal.employerCertId = ('tenant_certificate_id' in pred) ? pred.tenant_certificate_id : null
		},

		predictFiles() {
			this.predictionFetched = true
			this.spinner(true)

			let payload = {}

			if (this.editModal.payload.front_image_id)
				payload.front_image_id = this.editModal.payload.front_image_id
			if (this.editModal.payload.back_image_id)
				payload.back_image_id = this.editModal.payload.back_image_id

			if (!Object.keys(payload).length)
				return

			this.postData("CertificateUpload/predict", payload, true).then(response => {
				if (response.success)
					this.mapPredictionToCertificate(response.data)
				else
					this.predictionFetched = false

				this.spinner(false)
			})
		},

		bulkImportSaved() {
			this.importModalVisible = false
			this.fetchCerts()
		},
		uploadStarted() {
			this.editModal.uploadingInProgress++
		},
		approveAttachedCert(cert, employerCertId) {
			let vm = this

			let payload = {
				tenant_cert_id: employerCertId,
				user_cert_id: cert.id,
				user_cert_accepted: 1
			}

			this.postData("UserCompanyCertificate/save",payload,true).then(response => {
				if (response.success) {
					cert.UserCompanyCertificate[0].user_cert_accepted = true
					vm.alertSaved("Certificate approved!")
				}
			})
		},
		addCert() {
			this.editModal.visible = true
			this.editModal.title = "Add Certificate"
			this.editModal.editing = false

			this.editModal.payload = {
				cert_name: "",
				cert_number: "",
				issue_date: null,
				expiry_date: null,
				never_expires: false,
				instructor_name: "",
				training_location: "",
				issuing_org: ""
			}

			this.editModal.frontImageUrl = null
			this.editModal.backImageUrl = null
			this.editModal.backIsPdf = false
			this.editModal.frontIsPdf = false
			this.editModal.frontFileObj = null
			this.editModal.backFileObj = null
			this.editModal.employerCertId = null

			this.$set(this.editModal.payload,"never_expires",0)
		},
		editCert(cert) {
			this.editModal.visible = true
			this.editModal.title = "Edit Certificate"
			this.editModal.editing = true
			this.editModal.payload = cert

			this.editModal.frontImageUrl = window.apiRoot+"/resources/images/"+this.$store.sessionToken+"/"+cert.FrontImage.filename
			this.editModal.backImageUrl = window.apiRoot+"/resources/images/"+this.$store.sessionToken+"/"+cert.BackImage.filename

			this.editModal.frontFileObj = cert.FrontImage
			this.editModal.backFileObj = cert.BackImage

			this.editModal.employerCertId = cert.UserCompanyCertificate[0].tenant_cert_id
		},
		deleteCert(cert) {
			this.deleteId = cert.id
			this.deleteConfirmVisible = true
		},
		executeDeleteCert() {
			let vm = this

			this.postData("UserCertificate/delete",{id: this.deleteId},true).then(response => {
				if (response.success) {
					vm.alertSuccess("Certificate deleted")
					vm.deleteConfirmVisible = false
					vm.fetchCerts()
					vm.deleteConfirmVisible = false
				}
			})
		},
		cancelEditModal() {
			this.editModal.visible = false

			//delete any images that were uploaded
			let vm = this

			if (!("id" in this.editModal.payload) && this.editModal.payload.back_image_id)
				this.deleteImage(this.editModal.payload.back_image_id,true)

			if (!("id" in this.editModal.payload) && this.editModal.payload.front_image_id)
				this.deleteImage(this.editModal.payload.front_image_id,false)
		},
		deleteImage(id) {
			this.postData("UploadImage/delete",{id})
		},
		deletedImage(is_back) {
			if (is_back) {
				this.editModal.payload.back_image_id = null
				this.editModal.backImageUrl = false
			}
			else {
				this.editModal.payload.front_image_id = null
				this.editModal.frontImageUrl = false
			}
		},
		rotateImage(dir,is_back) {

			let payload = {
				rotate_direction: dir
			}

			if (is_back)
				payload.id = this.editModal.payload.back_image_id

			else
				payload.id = this.editModal.payload.front_image_id

			let vm = this

			this.postData("CertificateUpload/rotate",payload).then(response => {
				//strip query string, and then add another random one

				if (is_back) {
					let imageUrl = vm.editModal.backImageUrl ? vm.editModal.backImageUrl.split("?")[0] : false
					vm.editModal.backImageUrl = imageUrl+"?"+Math.random()
				}
				else {
					let imageUrl = vm.editModal.frontImageUrl ? vm.editModal.frontImageUrl.split("?")[0] : false
					vm.editModal.frontImageUrl = imageUrl+"?"+Math.random()
				}

				vm.$forceUpdate()
			})
		},
		fileUploaded(response,is_back) {
			let vm = this

			this.editModal.uploadingInProgress--

			if (is_back) {

				if (response.uploadData.file_ext.toLowerCase() == '.pdf') {
					this.editModal.backIsPdf = true
					this.editModal.backImageUrl = window.apiRoot+"resources/files/"+this.$store.sessionToken+"/"+response.data.filename+"?display=true"
				}
				else {
					this.editModal.backImageUrl = window.apiRoot+"resources/images/"+this.$store.sessionToken+"/"+response.data.filename
				}
				this.editModal.payload.back_image_id = response.data.id

			}
			else {
				if (response.uploadData.file_ext.toLowerCase() == '.pdf') {
					this.editModal.frontIsPdf = true
					this.editModal.frontImageUrl = window.apiRoot+"resources/files/"+this.$store.sessionToken+"/"+response.data.filename+"?display=true"
				}
				else {
					this.editModal.frontImageUrl = window.apiRoot+"resources/images/"+this.$store.sessionToken+"/"+response.data.filename
				}

				this.editModal.payload.front_image_id = response.data.id
			}

			this.predictionFetched = false  // new image! reset prediction status
		},
		saveCert() {
			let vm = this

			this.editModal.payload.user_id = this.$store.employee.id

			let payload = JSON.parse(JSON.stringify(this.editModal.payload))

			delete payload.created_at
			delete payload.updated_at
			delete payload.updated_by
			delete payload.BackImage
			delete payload.FrontImage
			delete payload.UserCompanyCertificate
			delete payload.User
			delete payload.frontImageUrl
			delete payload.backImageUrl
			delete payload.frontImageThumbUrl
			delete payload.backImageThumbUrl
			delete payload.backIsPdf
			delete payload.frontIsPdf
			delete payload.archived

			if (this.editModal.uploadingInProgress > 0)
				this.alertFail("Please wait until images have finished uploading")

			else {
				this.postData("UserCertificate/save",payload,true).then(response => {
					if (response.success) {

						payload = {
							tenant_cert_id: vm.editModal.employerCertId,
							user_cert_id: response.record_id
						}

						this.postData("UserCompanyCertificate/save",payload)

						vm.alertSaved("Certificate saved!")
						vm.editModal.visible = false
						vm.$store.errorList = {}
						vm.editModal.frontImageUrl = false
						vm.editModal.backImageUrl = false
						vm.fetchCerts()
					}
				})
			}
		},
		applyToCompanyCert(cert) {
			let vm = this

			let payload = {
				tenant_cert_id: cert.employerCertId,
				user_cert_id: cert.id
			}

			this.postData("UserCompanyCertificate/save",payload,true).then(response => {
				if (response.success)
					vm.alertSaved("Certificate applied!")
			})
		},
		toggleArchive(cert,archive) {
			let vm = this

			let payload = {
				id: cert.id,
				archived: archive ? 1 : 0
			}

			this.postData("UserCertificate/save",payload,true).then(response => {
				if (response.success) {
					if (archive)
						vm.alertSuccess("Certificate archived!")
					else
						vm.alertSuccess("Certificate un-archived!")

					vm.fetchCerts(spinner)
				}
			})
		},
		clearCertConnection(cert) {
			let vm = this

			if ("UserCompanyCertificate" in cert && cert.UserCompanyCertificate.length > 0) {

				let payload = {
					id: cert.UserCompanyCertificate[0].id
				}

				this.postData("UserCompanyCertificate/delete",payload,true).then(response => {
					if (response.success)
						cert.UserCompanyCertificate = []
				})
			}
		},
		fetchCerts(spinner) {
			let vm = this

			let params = {
				include: [
					"CertificateUpload",
					"UserCompanyCertificate",
					{model:"User",fields:["id","slug","first_name","last_name"]}
				]
			}

			let filters = [["user_id",this.$store.employee.id]]

			if (!vm.includeArchived)
				filters.push(["archived",0])

			params.filters = filters

			if (spinner)
				this.spinner(true)

			return new Promise((resolve,reject) => {
				vm.getJSON("UserCertificate/get",params,true).then(response => {

					if (spinner)
						vm.spinner(false)

					if (response.success) {
						vm.certs = response.data
					}

					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this

			let promises = [
				this.getJSON("CompanyCertificate/get"),
				this.fetchCerts(false)
			]

			vm.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				vm.companyCerts = responses[0].data

				vm.certs = responses[1].data
			})

		}
	},
	created() {
		if (!this.blockFetches)
			this.fetchData()

	}
}
</script>

<style type="text/css" scoped>

	.sparkles-icon {
		height: 1rem;
		width: 1rem;
		margin-left: -1rem;
		margin-right: 0.5rem;
	}

	.cert-title {
		text-transform: uppercase;
		text-decoration: none;
	}

	.upload-field {
		width:100%;
		height: 150px;
		margin-top:10px
	}

	.image-panel {
		max-height: 200px;
		height: 200px;
	}
</style>